import {Component, OnInit, Output, EventEmitter, isDevMode} from '@angular/core';
import {SearchService} from '@services/search.service';
import {ISearchObj} from '@models/search.interface';
import {EsriLoaderService} from '@services/esri-loader.service';

@Component({
  selector: 'app-search-short-results',
  templateUrl: './search-short-results.component.html',
  styleUrls: ['./search-short-results.component.scss']
})
export class SearchShortResultsComponent implements OnInit {

  uniqueAccounts: Array<any>;
  tableRows: number = 10;
  resultObject: ISearchObj;
  indexRow:number;
  first: number = 0;
  accountNbr: string;

 // @Output() uniqueAcc:EventEmitter<any>() = new EventEmitter();
  @Output() uniqueAcc: EventEmitter<any> = new EventEmitter();

  constructor(private searchSvc: SearchService, private esriLoaderService:EsriLoaderService) { }

  ngOnInit() {
    this.searchSvc.searchResults.subscribe(
      (newVals: ISearchObj) => {
        this.resultObject = newVals;
        this.uniqueAccounts =  Array.from(new Set(this.resultObject.rows.filter(this.noAddress)));
        if (isDevMode) {
          console.log("unique accounts: "+this.uniqueAccounts.length);
        }
        this.uniqueAcc.emit(this.uniqueAccounts);
      }
    );

    this.esriLoaderService.selectedAccountNumber.subscribe({
      next:(vals: any) => {
        this.mapSelectedHandler(vals);
      }
    });
  }

  //account:any = "";
  noAddress(element, index, array) {

    if(index !== 0){
      if(array[index-1].account_number == array[index].account_number){
        return false;
      } else {
        let y = element.geo_location.split(',')[0];
        let x = element.geo_location.split(',')[1];
        return x != undefined && y != undefined;
      }
    } else {
      return element.geo_location.split(',')[0] && element.geo_location.split(',')[1];
    }

  }

  mapSelectedHandler(val:any){
    this.indexRow = this.uniqueAccounts.findIndex(findindexHandler);

    function findindexHandler(property){
      return property.account_number == val;
    }

    if(this.indexRow >= 0) {
      let integerPart = Math.floor(this.indexRow/this.tableRows);
      this.first = integerPart*this.tableRows;
    }

  }

  shortListTableClickHandler(row:any) {
    this.accountNbr = "";
    this.esriLoaderService.selectedItem.next(row);
    this.mapSelectedHandler(row.account_number);
  }

  searchByAccountNbr() {
    this.indexRow = this.uniqueAccounts.findIndex(property => {
      return property.account_number === this.accountNbr.toLocaleUpperCase().trim();
    });

    if(this.indexRow >= 0) {
      let integerPart = Math.floor(this.indexRow/this.tableRows);
      this.first = integerPart*this.tableRows;
      this.esriLoaderService.selectedItem.next(this.uniqueAccounts[this.indexRow]);
    }  
  }

  clearSearchByAccountNbr() {
    if (this.accountNbr != "") {
      this.accountNbr = "";
      this.indexRow = -1;
    }
  }
}
